import React, { createContext, useContext, ReactNode, useState } from 'react';

export enum PossibleTypes {
    Society = 'society',
    Prescriber = 'prescriber',
    Publisher = 'publisher',
    PublisherReminder = 'publisher-reminder',
    ElectronicSign = 'electronic-sign',
    FormalityFolio = 'formality-folio',
    FormalityOrder = 'formality-order',
    FormalityInvoice = 'formality-invoice',
    Formality = 'formality',
    Catalogue = 'catalogue',
    Package = 'package',
    Article = 'article',
    Option = 'option',
    ComplementaryField = 'complementary-field',
    Document = 'document',
    Group = 'group',
    Offer = 'offer',
    PricesGrid = 'prices-grid',
    User = 'user',
    Antenne = 'antenne',
    WorkGroup = 'work-group',
}

interface SearchBarContextType {
    isSearchBarPath: boolean;
    setIsSearchBarPath: (value: boolean) => void;
    searchBarType?: PossibleTypes;
    setSearchBarType: (value?: PossibleTypes) => void;
}

const SearchBarContext = createContext<SearchBarContextType | undefined>(undefined);

interface SearchBarProviderProps {
    children: ReactNode;
}

export const SearchBarProvider: React.FunctionComponent<SearchBarProviderProps> = function ({
    children,
}) {
    const [isSearchBarPath, setIsSearchBarPath] = useState(false);
    const [searchBarType, setSearchBarType] = useState<PossibleTypes | undefined>(undefined);

    const value = React.useMemo(
        () => ({
            isSearchBarPath,
            setIsSearchBarPath,
            searchBarType,
            setSearchBarType,
        }),
        [isSearchBarPath, setIsSearchBarPath, searchBarType, setSearchBarType],
    );
    return <SearchBarContext.Provider value={value}>{children}</SearchBarContext.Provider>;
};

export const useSearchBar = (): SearchBarContextType => {
    const context = useContext(SearchBarContext);
    if (context === undefined) {
        throw new Error('useSearchBar must be used within a SearchBarProvider');
    }
    return context;
};
